import React, { PropTypes } from 'react';
import SelectItemModal from 'template/Modals/SelectItem';
import Teacher from 'mediators/Teacher';

//
// User can select a teacher within a class
// a wraper of SelectItemModal
//
// eg.
// SelectClassTeacher({ classId })
//  .then()
//  .catch()
//
export default function(opts) {

  const { schoolId, conflictedIDs, state } = opts;
  let filterOptions = [];
  if(state == 'student'){
    filterOptions = [
      {'name': __('Unchecked', 'teacherAttendance'), 'value': 'unchecked'},
      {'name': __('Attended', 'teacherAttendance'), 'value': 'attended'},
      {'name': __('Absent (with excuse)', 'teacherAttendance'), 'value': 'absent (with excuse)'},
      {'name': __('Absent (without notice)', 'teacherAttendance'), 'value': 'absent (without notice)'}
    ]
  }else {
    filterOptions = [
      {'name': __('Attended', 'teacherAttendance'), 'value': 'attended'},
      {'name': __('Absent (with excuse)', 'teacherAttendance'), 'value': 'absent (with excuse)'},
      {'name': __('Absent (without notice)', 'teacherAttendance'), 'value': 'absent (without notice)'},
    ]
  }
  // this will return a promise
  return SelectItemModal({
    headerTitle: __('Select Status', 'teacherAttendance'),
    headerIcon: 'fa icon-ok',
    itemName: __('Status', 'teacherAttendance'),
    searchPlaceholder: __('Attendance Status', 'teacherAttendance'),
    hideSearchbar: true,
    fetchItems: (cb)=>{
      cb(filterOptions)
    },

    components: {
      SelectItem: ({item, getItemLabel, selected, onClickSelect, selectText, selectedText, mixin}) => {

        return (
          <div className='select-item' >
            <div>
              { item.name }
            </div>
            <div className='select-button'>
              { selected && <span className='btn-link currently-selected' onClick={onClickSelect}>{selectText || __('Selected', 'SelectItemModal')}</span>}
              { !selected && <span className='btn-link' onClick={onClickSelect}>{selectedText || __('Select', 'SelectItemModal')}</span>}
            </div>
          </div>
         );
      }
    },
    selectFilter: (item, alreadySelected, selected)=>{
      return alreadySelected.value == item.value;
    },

    selected: opts.selected,

    ...opts,

  })
}



// WEBPACK FOOTER //
// ./src/template/Modals/SelectAttendanceStatus/index.js